module.exports = __webpack_public_path__ + "img/icon_item3.99d78d12.png";